export const videosEnglish = [
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/English/intro.MP4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  },
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/English/v1.MP4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  },
 
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/English/v3.mp4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  },
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/English/v4.mp4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  },
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/English/v5.mp4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  }
];

export const videosSpanish = [
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/Spenish/Intro_Draft01-Spanish.mp4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  },
  
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/Spenish/Video01_Draft02-Spanish.mp4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  },
 
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/Spenish/Video02_Draft04-Spanish.mp4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  },
  
  
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/Spenish/Video03_Draft02-Spanish.mp4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  },
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/Spenish/Video04_Draft06-Spanish.mp4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  },
  {
    type: 'video',
    sources: [
      {
        src: require("../../assets/Videos/Spenish/Video05_Draft02-Spanish.mp4"),
        type: 'video/mp4',
        size: 720,
      }
    ],
  }
];
